import useEnv from "./useEnv";

export const useFlag = (flag: string) => {
  const { selectedEnv } = useEnv();
  return selectedEnv?.flag_decisions[flag] ?? false;
};
